export const templateColumnConfigs = [
  {
    header: 'Application Name*',
    key: 'application',
    width: 40,
    required: true,
    example: 'Sample Application',
    type: 'Text',
  },
  {
    header: 'Application Type*',
    key: 'applicationType',
    width: 50,
    required: true,
    options: ['ENTERPRISE', 'LOCATIONS'],
    example: 'ENTERPRISE',
    type: 'Dropdown',
  },
  {
    header: 'Description (Optional)',
    key: 'description',
    width: 50,
    required: false,
    example: 'This is a sample application description.',
    type: 'TextArea',
  },
  {
    header: 'Maximum Tolerable Outage (MTO) (Optional)',
    key: 'mto',
    width: 45,
    required: false,
    example: 24,
    type: 'Number (hours)',
  },
  {
    header: 'Recovery Time Objective (RTO) (Optional)',
    key: 'rto',
    width: 40,
    required: false,
    example: 12,
    type: 'Number (hours)',
  },
  {
    header: 'Recovery Point Objective (RPO) (Optional)',
    key: 'rpo',
    width: 40,
    required: false,
    example: 6,
    type: 'Number (hours)',
  },
  {
    header: 'Service Level Agreement (SLA) (Optional)',
    key: 'sla',
    width: 40,
    required: false,
    example: 4,
    type: 'Number (hours)',
  },
  {
    header: 'DRP Link (Optional)',
    key: 'drpLink',
    width: 40,
    required: false,
    example: 'http://example.com/drp-link',
    type: 'Link',
  },
  {
    header: 'DRP Date (Optional)',
    key: 'drpDate',
    width: 30,
    required: false,
    example: '2024-12-16',
    type: 'Date',
  },
  {
    header: 'Last DRP Test (Optional)',
    key: 'lastDrpTest',
    width: 30,
    required: false,
    example: '2024-11-01',
    type: 'Date',
  },
  {
    header: 'Supports Reputation (Optional)',
    key: 'supportsReputation',
    width: 30,
    required: false,
    example: true,
    type: 'Boolean',
  },
  {
    header: 'Supports Employees (Optional)',
    key: 'supportsEmployees',
    width: 30,
    required: false,
    example: true,
    type: 'Boolean',
  },
  {
    header: 'Supports Life Safety (Optional)',
    key: 'supportsLifeSafety',
    width: 30,
    required: false,
    example: false,
    type: 'Boolean',
  },
  {
    header: 'Supports Regulation (Optional)',
    key: 'supportsRegulation',
    width: 30,
    required: false,
    example: true,
    type: 'Boolean',
  },
  {
    header: 'Supports Other (Optional)',
    key: 'supportsOther',
    width: 50,
    required: false,
    example: 'This application supports other business needs.',
    type: 'TextArea',
  },
];
